export { getAllInfo, userSlice } from './model/user-type-slice'
export * from './model'